import Carousel from "react-bootstrap/Carousel";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

interface OpinionsCarouselProps {}

const OpinionsCarousel: React.FC<OpinionsCarouselProps> = (props) => {
  return (
    <Carousel fade nextIcon={<FontAwesomeIcon icon={faChevronRight} style={{ color: "#43b4e9" }} />} prevIcon={<FontAwesomeIcon icon={faChevronLeft} style={{ color: "#43b4e9" }} />}>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>I`m impressed how smoothly the process went and with the speed and quality of the translation.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Sylwia Pałucka</h3>
          <p className="text-sm text-black">Bel Polska</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>The translation was great. This program meets expectations.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Ray Pace</h3>
          <p className="text-sm text-black">Sumitomo Australia Pty Ltd</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>Everything went very well as expected.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Ing. Pai Soe Aung</h3>
          <p className="text-sm text-black">SBOMBAS HIDRÁULICAS S.A. DE C.V.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>The document was translated excellently.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Miroslav Šianský</h3>
          <p className="text-sm text-black">INTEBO</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>I’m very happy with the results.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Buzon marketing</h3>
          <p className="text-sm text-black">VASALTO Tech and Talent</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>Your product is absolutely gorgeous.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Zsolt Horváth-Sütő</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>It's an amazing platform, it helped me a lot. No issues.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Eliza Konovalova</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item className="opinion-item">
        <div className="text-xl h-60 px-2 py-2 rounded-lg ">
          <span>I was testing the system, as I heard about it and it was a positive experience.</span>
        </div>
        <Carousel.Caption className="text-sm mt-4">
          <h3 className="text-sm text-black">Sandra Nunes</h3>
          <p className="text-sm text-black">Abreu Events</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};

export default OpinionsCarousel;
